import React from 'react';
import { Popover, PopoverContent, PopoverTrigger } from '@/components/ui/popover';
import { Info } from 'lucide-react';

const RATES = {
  default: { withAccommodation: 102, selfAccommodation: 171 },
  premium: { withAccommodation: 128, selfAccommodation: 214 },
};

const PREMIUM_COUNTRIES = [
  'Austria', 'Australia', 'Belgium', 'Canada', 'Denmark',
  'Finland', 'France', 'Germany', 'Hong Kong', 'Iceland',
  'Ireland', 'Italy', 'Japan', 'Netherlands', 'Norway',
  'Singapore', 'South Korea', 'Sweden', 'Switzerland',
  'United Kingdom', 'USA',
];

interface PerDiemRatesInfoProps {
  displayValue: React.ReactNode;
}

export const PerDiemRatesInfo: React.FC<PerDiemRatesInfoProps> = ({ displayValue }) => {
  return (
    <Popover>
      <PopoverTrigger asChild>
        <button
          className="inline-flex items-center gap-1 hover:bg-gray-100 px-1 py-0.5 rounded cursor-pointer"
          onClick={(e) => e.stopPropagation()}
        >
          {displayValue}
          <Info className="h-3 w-3 text-muted-foreground" />
        </button>
      </PopoverTrigger>
      <PopoverContent className="w-[50vw] p-3" align="center">
        <p className="text-sm font-semibold mb-2">Per Diem Daily Rates (USD)</p>
        <table className="text-sm border-collapse">
          <thead>
            <tr>
              <th className="text-left pr-4 pb-1 text-muted-foreground font-medium"></th>
              <th className="text-right pr-4 pb-1 text-muted-foreground font-medium">With Accommodation</th>
              <th className="text-right pb-1 text-muted-foreground font-medium">Self Accommodation</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td className="pr-4 py-0.5 font-medium">Default</td>
              <td className="text-right pr-4 py-0.5">${RATES.default.withAccommodation}</td>
              <td className="text-right py-0.5">${RATES.default.selfAccommodation}</td>
            </tr>
            <tr>
              <td className="pr-4 py-0.5 font-medium">Premium (+25%)</td>
              <td className="text-right pr-4 py-0.5">${RATES.premium.withAccommodation}</td>
              <td className="text-right py-0.5">${RATES.premium.selfAccommodation}</td>
            </tr>
          </tbody>
        </table>
        <div className="mt-2 pt-2 border-t">
          <p className="text-xs text-muted-foreground font-medium mb-1">Premium countries:</p>
          <p className="text-xs text-muted-foreground leading-relaxed">
            {PREMIUM_COUNTRIES.join(', ')}
          </p>
        </div>
      </PopoverContent>
    </Popover>
  );
};
